import { FC } from "react";
import { Typo3Input } from "./Input";

export interface Typo3InputPropsI {
  type: string;
  properties?: any;
  identifier: string;
  label: string;
  name: string;
  validators?: { identifier: string }[];
  as?: "input" | "select" | "textarea";
  disabled?: boolean;
  className?: string;
  defaultValue?: string;
  value?: string | number;
  renderingOptions?: any;
}

export const Hidden: FC<Typo3InputPropsI> = ({
  defaultValue,
  renderingOptions,
  ...props
}) => <Typo3Input {...props} type="hidden" />;
export const Password: FC<Typo3InputPropsI> = ({
  defaultValue,
  renderingOptions,
  ...props
}) => <Typo3Input {...props} type="password" />;
export const Email: FC<Typo3InputPropsI> = ({
  defaultValue,
  renderingOptions,
  ...props
}) => <Typo3Input {...props} type="email" />;
export const Telephone: FC<Typo3InputPropsI> = ({
  defaultValue,
  renderingOptions,
  ...props
}) => <Typo3Input {...props} type="tel" />;
export const Url: FC<Typo3InputPropsI> = ({
  defaultValue,
  renderingOptions,
  ...props
}) => <Typo3Input {...props} type="url" />;
export const Number: FC<Typo3InputPropsI> = ({
  defaultValue,
  renderingOptions,
  ...props
}) => <Typo3Input {...props} type="number" />;
export const Date: FC<Typo3InputPropsI> = ({
  defaultValue,
  renderingOptions,
  ...props
}) => <Typo3Input {...props} type="date" />;
export const Text: FC<Typo3InputPropsI> = ({
  defaultValue,
  renderingOptions,
  ...props
}) => <Typo3Input {...props} type="text" />;
